import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-comment-select-dialog',
  templateUrl: './withdraw-offers-dialog.component.html',
  styleUrls: ['./withdraw-offers-dialog.component.scss']
})
export class WithdrawOffersDialogComponent {
  constructor(public translate: TranslateService, public dialogRef: MatDialogRef<WithdrawOffersDialogComponent>) {}

  save(): void {
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/offers/offer-list/witdraw-offers-dialog/withdraw-offers-dialog.component.ts